import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';
import { FeedbackService } from '../../services/feedback.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-fbreport',
  templateUrl: './fbreport.component.html',
  styleUrls: ['./fbreport.component.scss'],
  providers:[MasterService,FeedbackService]
})
export class FbreportComponent implements OnInit {
  attstaff: any;
  arrres: any;

 constructor(private http: HttpClient,private fservice:FeedbackService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

    sections:any=[];
    classes:any=[];
    arrsubjects:any=[];
    fmodel:any={clid:'0',secid:'0',suid:'0',crid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    oprtype:any='';
    tabledata: any = {};
    arrcourse:any=[];
  ngOnInit(): void {
    this.mascourse();
  }

  mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrcourse = resultArray;
              this.fmodel.crid=resultArray[0].crid;
              this.masclass();
              //this.fmodel1.crid=resultArray[0].crid;
          },
          error => console.log("Error :: " + error)
          )
    }
    masclass() {
      this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.massection();
              
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

     massection() {
      this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.scid=resultArray[0].scid;
             // this.masasshead();
             this. subjects();
          },  
          error => console.log("Error :: " + error)
          )
    }

    subjects() {
        this.mservice.subjectsrolewise(0,0,this.fmodel.clid,'asaa',this.fmodel.crid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrsubjects = resultArray;
                this.fmodel.suid=resultArray[0].suid;
                this.getsubjectstaff();
            },
            error => console.log("Error :: " + error)
            )
      }

       getsubjectstaff() {
        debugger
        this.mservice.getsubjectstaff(this.fmodel.crid,this.fmodel.clid,this.fmodel.scid,this.fmodel.suid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.attstaff = resultArray;
                this.fmodel.emid=resultArray[0].emid;
                this.getfedrecrpt();
            },
            error => console.log("Error :: " + error)
            )
      }

       getfedrecrpt() {
        debugger
        this.mservice.getfedrecrpt(this.fmodel.crid,this.fmodel.clid,this.fmodel.scid,this.fmodel.suid,this.fmodel.emid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrres = resultArray;
                // this.fmodel.emid=resultArray[0].emid;
            },
            error => console.log("Error :: " + error)
            )
      }

}
